import axios from "axios";
const token = localStorage.getItem("token");
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL
    ? process.env.REACT_APP_API_URL
    : "https://api.planium.ir/api",
  headers: { Authorization: token ? `Bearer ${token}` : null },
});
export default api;
